import React from "react";
import { useCallback } from "react";
import { Link } from "react-router-dom";

export default function HeroSection() {
  const handleScrollToPlan = useCallback((e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const el = document.getElementById("summary-plan");
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 56;
      window.scrollTo({ top, behavior: "smooth" });
    }
  }, []);

  return (
    <section id="home" className="relative w-full overflow-hidden" style={{ minHeight: "520px" }}>
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=elegant%20concert%20hall%20interior%20with%20warm%20golden%20stage%20lighting%2C%20rows%20of%20empty%20seats%2C%20grand%20architecture%2C%20deep%20navy%20and%20gold%20tones%2C%20sophisticated%20atmosphere%2C%20professional%20photography%2C%20wide%20angle%2C%20no%20people%2C%20classical%20music%20venue%2C%20ornate%20ceiling%20details&width=1400&height=600&seq=mpf-hero-bg-01&orientation=landscape')`,
        }}
      />
      {/* Dark overlay for contrast */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#0d1f4c]/90 via-[#0d1f4c]/75 to-[#0d1f4c]/40" />

      {/* Content */}
      <div className="relative z-10 max-w-[1200px] mx-auto px-6 py-20 md:py-28 w-full">
        <div className="max-w-[620px] motion-safe:animate-[heroFadeIn_0.7s_ease-out_forwards]">
          {/* Eyebrow */}
          <div className="flex items-center gap-2 mb-5">
            <div className="w-8 h-0.5 bg-[#1a8fc1]"></div>
            <span className="text-[#7ec8e3] text-sm font-semibold tracking-widest uppercase">
              Musicians&apos; Pension Fund of Canada
            </span>
          </div>

          {/* Headline */}
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-5">
            Helping Canadian Musicians Build{" "}
            <span className="text-[#7ec8e3]">Retirement Security</span>
          </h1>

          {/* Subheadline */}
          <p className="text-base md:text-lg text-white/80 leading-relaxed mb-8 max-w-[520px]">
            The Musicians&apos; Pension Fund of Canada administers pension benefits for eligible members and beneficiaries across Canada.
          </p>

          {/* CTA buttons */}
          <div className="flex flex-wrap gap-3">
            <a
              href="/#summary-plan"
              onClick={handleScrollToPlan}
              className="flex items-center gap-2 px-6 py-3 bg-[#1a8fc1] hover:bg-[#1578a3] text-white font-semibold rounded-md transition-colors cursor-pointer whitespace-nowrap text-sm"
            >
              <i className="ri-file-text-line"></i>
              Learn About the Plan
            </a>
            <Link
              to="/resources"
              className="flex items-center gap-2 px-6 py-3 bg-white/10 hover:bg-white/20 border border-white/40 text-white font-semibold rounded-md transition-colors cursor-pointer whitespace-nowrap text-sm backdrop-blur-sm"
            >
              <i className="ri-folder-open-line"></i>
              Find Resources
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom fade */}
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-[#f4f8fc] to-transparent" />
    </section>
  );
}
